import React from 'react';
import { Helmet } from 'react-helmet';
import config from '../config';

export default function BusinessFavicon({ name, logo }) {
  return (
    <Helmet>
      <meta charset="utf-8" />
      <title>{name}</title>
      <link rel="icon" href={logo} />
      <meta httpEquiv="X-UA-Compatible" content="IE=edge" />
      
      {/* SEO meta tags */}
      <meta name="description" content={name} />
      <meta name="robots" content="noodp" />
      <meta name="csrf_token" content="" />
      <meta name="_token" content="" />
      
      {/* Open Graph meta tags */}
      <meta property="og:url" content={config.BixPublicUrl} />
      <meta property="og:type" content="website" />
      <meta property="og:title" content={name} />
      <meta property="og:description" content={name} />
      <meta property="og:image" content={logo} />
      <meta property="og:image:type" content="image/png" />
      <meta property="og:locale" content="en_US" />
      <meta property="og:author" content="Bixjet" />
      <meta property="og:updated_time" content="1440432930" />
      <meta property="li:company" content="1234567" />

      {/* Twitter Card meta tags */}
      <meta name="twitter:card" content={name} />
      <meta name="twitter:title" content={name} />
      <meta name="twitter:description" content={name} />
      <meta name="twitter:image" content={logo} />
      
      {/* Other meta tags */}
      <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" />
      <meta name="theme-color" content="#ffffff" />
      <meta name="msapplication-TileColor" content="#ffffff" />
      <meta name="msapplication-TileImage" content="/ms-icon-144x144.png" />
    </Helmet>
  );
}
